import React from "react"
import "./mark.css"
function Mark(){
    return(
      <>
       
      
      <body className="mark">
      
      <section className="fotosMaxxa">
      <img className="markTop" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/logos%20marcar%2Fmark3.png?alt=media&token=fd11cc63-1712-4eb4-8a2f-25d0d300b7be"  alt="..." />
        <br></br>
        <div class="container px-4 px-lg-5 mt-5">
              <div class="row gx-4 gx-lg-5 row-cols-2 row-cols-md-3 row-cols-xl-4 justify-content-center">
                  <div class="col mb-5">
                    <div className="backMark"> 
                      <div class="card h-100">
                          <img className="fotoProd" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/mark%2Fi5.jpeg?alt=media&token=d9813734-0574-4cb8-89b5-c42eed14a9e2" /> 
                          <div class="card-body p-4">
                            <div class="text-center">
                              <h5 class="fw-bolder">I5 
                              <p>Earphone</p>
                              </h5>
                             
                             </div>
                          </div>
                          </div>  
                          
                      </div>
                  </div>
                  <div class="col mb-5">
                    <div className="backMark"> 
                      <div class="card h-100">
                          <img className="fotoProd" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/mark%2Fdr-10%20micro%20usb.jpeg?alt=media&token=16b8a36e-977d-4d76-b759-4d4b6526ba84" /> 
                          <div class="card-body p-4">
                            <div class="text-center">
                              <h5 class="fw-bolder">DR-10
                              <p>Micro Usb 5A</p>
                              </h5>
                             
                             </div>
                          </div>
                          </div>  
                          
                      </div>
                  </div>
                  <div class="col mb-5">
                  <div className="backMark">
                      <div class="card h-100">
                          <img className="fotoProd" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/mark%2Fdr-10%20lightning.jpeg?alt=media&token=faafb0df-d19a-4bb7-bf5e-bebfe7d79588" alt="..." />
                          <div class="card-body p-4">
                            <div class="text-center">
                              <h5 class="fw-bolder">DR-10
                              <p>Lightning A</p>
                              </h5>
                              
                             </div>
                          </div>
                         </div>
                         
                      </div>
                  </div>
                  <div class="col mb-5">
                  <div className="backMark">
                      <div class="card h-100">
                          <img className="fotoProd" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/mark%2Fdr-10%20type%20c.jpeg?alt=media&token=13e2cb96-595b-40f6-8021-331034d7be1d" alt="imagen de back" />
                          <div class="card-body p-4">
                            <div class="text-center">
                              <h5 class="fw-bolder">DR-10
                              <p>Type C 5A</p>
                              </h5>
                            
                             </div>
                          </div>
                         
                          </div>
                      </div>
                  </div>
                  <div class="col mb-5">
                  <div className="backMark">
                      <div class="card h-100">
                          <img class="fotoProd" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/mark%2Fj3.jpeg?alt=media&token=7ed175e4-8654-490b-9d0c-44c1d5cb2c40" alt="..." />
                          <div class="card-body p-4">
                            <div class="text-center">
                              <h5 class="fw-bolder">J3
                              <p>Car Holder</p>
                              </h5>
                             
                             </div>
                          </div>
                         
                          </div>
                      </div>
                  </div>
                  <div class="col mb-5">
                  <div className="backMark">
                      <div class="card h-100">
                          <img class="fotoProd" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/mark%2Fdr-10%20micro%20usb.jpeg?alt=media&token=16b8a36e-977d-4d76-b759-4d4b6526ba84" alt="..." />
                          <div class="card-body p-4">
                            <div class="text-center">
                              <h5 class="fw-bolder">DR-10
                              <p>Micro Usb 3A</p>
                              </h5>
                            
                             </div>
                          </div>
                         </div>
                          
                      </div>
                  </div><div class="col mb-5">
                  <div className="backMark">
                      <div class="card h-100">
                          <img class="fotoProd" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/mark%2Fdr-10%20lightning.jpeg?alt=media&token=faafb0df-d19a-4bb7-bf5e-bebfe7d79588" alt="..." />
                          <div class="card-body p-4">
                            <div class="text-center">
                              <h5 class="fw-bolder">DR-10
                              <p>Lightning 3A</p>
                              </h5>
                              
                             </div>
                          </div>
                         
                          </div>
                      </div>
                  </div>
                  <div class="col mb-5">
                  <div className="backMark">
                      <div class="card h-100">
                          <img class="fotoProd" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/mark%2Fdr-10%20type%20c.jpeg?alt=media&token=13e2cb96-595b-40f6-8021-331034d7be1d" alt="..." />
                          <div class="card-body p-4">
                            <div class="text-center">
                              <h5 class="fw-bolder">DR-10
                              <p>Type C 3A</p>
                              </h5>
                             
                             </div>
                          </div>
                         
                          </div>
                      </div>
                  </div>
                 
                  </div>
                  </div>      
      </section>
   </body>   
  
   </>
       
      
    
    )
}

export default Mark